let mock = [{
  "id":"51-236-0885",
  "origin_city":"Salt Lake City",
  "origin_country":"United States",
  "destination_city":"Atlanta",
  "destination_country":"United States",
  "ticket_price":100.18,
  "duration":240,
  "check_bag_free":true,
  "check_bag_price":0
}, {
  "id":"51-236-0885",
  "origin_city":"Salt Lake City",
  "origin_country":"United States",
  "destination_city":"Guadalajara",
  "destination_country":"Mexico",
  "ticket_price":116.18,
  "duration":300,
  "check_bag_free":false,
  "check_bag_price":20
}, {
  "id":"51-236-0885",
  "origin_city":"Salt Lake City",
  "origin_country":"United States",
  "destination_city":"Sadkowice",
  "destination_country":"Poland",
  "ticket_price":198.18,
  "duration":66,
  "check_bag_free":true,
  "check_bag_price":0
}, {
  "id":"20-170-9839",
  "origin_city":"Salt Lake City",
  "origin_country":"United States",
  "destination_city":"Apt",
  "destination_country":"France",
  "ticket_price":198.57,
  "duration":176,
  "check_bag_free":false,
  "check_bag_price":84
}, {
  "id":"73-278-9993",
  "origin_city":"Salt Lake City",
  "origin_country":"United States",
  "destination_city":"Pécs",
  "destination_country":"Hungary",
  "ticket_price":329.63,
  "duration":198,
  "check_bag_free":true,
  "check_bag_price":0
}, {
  "id":"80-865-5562",
  "origin_city":"Salt Lake City",
  "origin_country":"United States",
  "destination_city":"Kafr Dān",
  "destination_country":"Palestinian Territory",
  "ticket_price":233.55,
  "duration":142,
  "check_bag_free":true,
  "check_bag_price":0
}, {
  "id":"50-771-2752",
  "origin_city":"Salt Lake City",
  "origin_country":"United States",
  "destination_city":"Shatian",
  "destination_country":"China",
  "ticket_price":82.21,
  "duration":147,
  "check_bag_free":true,
  "check_bag_price":0
}, {
  "id":"27-281-4149",
  "origin_city":"Salt Lake City",
  "origin_country":"United States",
  "destination_city":"Padre Las Casas",
  "destination_country":"Dominican Republic",
  "ticket_price":390.86,
  "duration":204,
  "check_bag_free":true,
  "check_bag_price":0
}, {
  "id":"65-215-0565",
  "origin_city":"Salt Lake City",
  "origin_country":"United States",
  "destination_city":"Libato",
  "destination_country":"Philippines",
  "ticket_price":388.64,
  "duration":225,
  "check_bag_free":false,
  "check_bag_price":28
}, {
  "id":"61-576-7393",
  "origin_city":"Salt Lake City",
  "origin_country":"United States",
  "destination_city":"Solna",
  "destination_country":"Sweden",
  "ticket_price":210.36,
  "duration":316,
  "check_bag_free":true,
  "check_bag_price":0
}, {
  "id":"71-617-3411",
  "origin_city":"Salt Lake City","origin_country":"United States","destination_city":"Leninogorsk","destination_country":"Russia","ticket_price":252.37,"duration":134,"check_bag_free":true,"check_bag_price":0},
{"id":"38-393-4867","origin_city":"Salt Lake City","origin_country":"United States","destination_city":"Pingpu","destination_country":"China","ticket_price":124.13,"duration":88,"check_bag_free":false,"check_bag_price":57},
{"id":"14-444-6494","origin_city":"Salt Lake City","origin_country":"United States","destination_city":"Jinshanwei","destination_country":"China","ticket_price":362.71,"duration":134,"check_bag_free":false,"check_bag_price":79},
{"id":"84-521-4129","origin_city":"Salt Lake City","origin_country":"United States","destination_city":"Tabou","destination_country":"Ivory Coast","ticket_price":90.06,"duration":289,"check_bag_free":true,"check_bag_price":0},
{"id":"68-542-4001","origin_city":"Salt Lake City","origin_country":"United States","destination_city":"Ngawi","destination_country":"Indonesia","ticket_price":317.42,"duration":117,"check_bag_free":true,"check_bag_price":0},
{"id":"51-561-1547","origin_city":"Salt Lake City","origin_country":"United States","destination_city":"La Salud","destination_country":"Cuba","ticket_price":202.04,"duration":91,"check_bag_free":false,"check_bag_price":37},
{"id":"97-408-4405","origin_city":"Salt Lake City","origin_country":"United States","destination_city":"Basa","destination_country":"Indonesia","ticket_price":200.22,"duration":94,"check_bag_free":false,"check_bag_price":28},
{"id":"54-791-8657","origin_city":"Salt Lake City","origin_country":"United States","destination_city":"Svetlyy Yar","destination_country":"Russia","ticket_price":301.65,"duration":328,"check_bag_free":false,"check_bag_price":52},
{"id":"81-385-4916","origin_city":"Salt Lake City","origin_country":"United States","destination_city":"Austin","destination_country":"United States","ticket_price":343.83,"duration":186,"check_bag_free":false,"check_bag_price":59},
{"id":"41-661-8463","origin_city":"Salt Lake City","origin_country":"United States","destination_city":"Correia Pinto","destination_country":"Brazil","ticket_price":94.07,"duration":205,"check_bag_free":false,"check_bag_price":40},
{"id":"90-629-3671","origin_city":"Salt Lake City","origin_country":"United States","destination_city":"Salvador","destination_country":"Portugal","ticket_price":383.94,"duration":193,"check_bag_free":false,"check_bag_price":87},
{"id":"31-238-7160","origin_city":"Salt Lake City","origin_country":"United States","destination_city":"Fécamp","destination_country":"France","ticket_price":379.21,"duration":220,"check_bag_free":false,"check_bag_price":77}]

export default mock;
